import Image from 'next/image';
import BackgroundImage from './bigbar_background.svg?url';

export const BigBar: React.FC<
  React.PropsWithChildren<{
    title: string | string[];
    comment?: string;
  }>
> = ({ title, comment = '', children }) => (
  <div className="relative min-h-48 w-full pb-8 pt-16">
    <div className="absolute inset-0 bg-main-100" />
    <Image
      src={BackgroundImage}
      alt=""
      className="absolute inset-0 mx-auto size-full max-w-200 object-cover"
    />
    <div className="cst-side-space relative mx-auto max-w-180">
      <h1 className="break-keep text-h2 font-bold cst-halt leading-[1.4] text-base-100">
        {Array.isArray(title)
          ? title.map((value) => (
              <span key={value} className="inline-block">
                {value}
              </span>
            ))
          : title}
      </h1>
      {comment && (
        <p className="mt-2 text-base2 leading-[1.6] text-base-100">{comment}</p>
      )}
      {children && <div className="mt-4">{children}</div>}
    </div>
  </div>
);

export const BigBarBackground: React.FC = () => (
  <div className="absolute min-h-48 w-full pb-8 pt-16">
    <div className="absolute inset-0 bg-main-100" />
    <Image
      src={BackgroundImage}
      alt=""
      className="absolute inset-0 mx-auto size-full max-w-[800px] object-cover"
    />
  </div>
);
